import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

export function initializeFontAwesome() {
	library.add(fas);
}
